import React, { Dispatch, FC, SetStateAction, SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";

import { Tabs } from "@components/common";
import { ESRS_REPORT_ID } from "@constants";

export type Tab =
  | "overview"
  | "ghc-scopes"
  | "category-insights"
  | "modeling"
  | "esrs";

export const tabs: {
  title: string;
  path: Tab;
  pageId: string;
  reportId?: string;
}[] = [
  {
    title: "co2.hub.dashboard.report.overview",
    path: "overview",
    pageId: "ReportSection26e61161ba67f1b35b4b",
  },
  {
    title: "co2.hub.dashboard.report.esrs",
    path: "esrs",
    pageId: "5d1d2a8c6384385c4342",
    reportId: ESRS_REPORT_ID,
  },
  {
    title: "co2.hub.dashboard.report.ghgScopes",
    path: "ghc-scopes",
    pageId: "ReportSectionfd69324ccf5b882732a0",
  },
  {
    title: "co2.hub.dashboard.report.categoryInsights",
    path: "category-insights",
    pageId: "ReportSection05d8e1a6039009ee5bd7",
  },
  {
    title: "co2.hub.dashboard.report.modeling",
    path: "modeling",
    pageId: "ReportSection98989a039c6a4d1dacfa",
  },
];

interface Component {
  activeTab: Tab;
  setActiveTab: Dispatch<SetStateAction<Tab>>;
  version: "co2" | "esrs";
}

const Component: FC<Component> = ({ activeTab, setActiveTab, version }) => {
  const handleTabChange = (event: SyntheticEvent, value: Tab): void => {
    setActiveTab(value);
  };
  const { t } = useTranslation();

  return (
    <Tabs<Tab>
      tabs={tabs
        .filter((tab) => version !== "co2" || tab.path !== "esrs")
        .map((tab) => ({ title: t(tab.title), path: tab.path }))}
      activeTab={(activeTab as Tab) || "overview"}
      onChange={handleTabChange}
    />
  );
};

export default Component;
